export default __webpack_public_path__ + "static/media/arrow-left-black.2754a96a.svg";